import Swiper from "swiper";
import { Navigation, Pagination, Parallax, Mousewheel } from "swiper/modules";

let Slider = {};

Slider.initSwiper = (object, params = {}) => {
	return new Swiper(object, {
		modules: [Navigation, Pagination, Parallax, Mousewheel],
		slidesPerView: 1,
		loop: false,
		...params,
	});
};

// Sliders Mobile : Activate only unde 768px
let $slidersMobile = document.querySelectorAll(".slider-mobile");
let swiperMobile = {};
let init = false;
const sliderMobile = (e) => {
	if (window.innerWidth <= 577) {
		if (!init) {
			init = true;
			$slidersMobile.forEach((slider) => {
				swiperMobile = new Swiper(slider, {
					modules: [Pagination],
					slidesPerView: 1.2,
					spaceBetween: 10,
					loop: false,
					centeredSlides: true,
					pagination: {
						el: slider.parentElement.querySelector(".swiper-pagination-sm"),
						type: "bullets",
					},
				});
			});
		}
	} else if (init) {
		swiperMobile.forEach((slider) => {
			slider.destroy();
		});
		init = false;
	}
};

if ($slidersMobile.length > 0) {
	sliderMobile();
	window.addEventListener("resize", sliderMobile);
}

export default Slider;
